import React from 'react';
import { Box, Stack } from '@mui/material';
import { TemplateFormComponent } from 'components/common/form/layout/ReactHookFormController';
import useCustomSimplifiedForm from 'components/common/form/hooks/useCustomSimplifiedForm';

export default function DevAppBuilderFormComponents() {
    const form = useCustomSimplifiedForm({
        columnsList: JSON.stringify([
            {
                column: 'value 1',
                color: '#FF0000',
            },
            {
                column: 'value 2',
                color: '#00FF00',
            },
            {
                column: 'value 3',
                color: '#0000FF',
            },
        ]),
    });

    return (
        <Stack spacing={1}>
            <Box>AppBuilder Components Example</Box>
            <Box>
                <TemplateFormComponent
                    component={'FormChartColumnsList'}
                    elementProps={form}
                    name={'columnsList'}
                    props={{
                        urlParams: {
                            datasetId: 10,
                        },
                        columnsUrl: '/data/dev/form/refresh-component',
                    }}
                />
            </Box>
        </Stack>
    );
}
